import BigNumber from 'bignumber.js';
import { Address } from 'viem';

import { getDelegateStakingPoolContract } from 'modules/api/contracts/getDelegateStakingPoolContract';
import { getPublicClient } from 'modules/api/getPublicClient';
import { convertFromWei } from 'modules/api/utils';

export async function getOwnerSelfStakeAmount(
  poolAddress: Address,
): Promise<BigNumber> {
  const poolContract = getDelegateStakingPoolContract(
    getPublicClient(),
    poolAddress,
  );

  const availableSelfStakeWei = await poolContract.read.getAvailableSelfStake();

  return convertFromWei(availableSelfStakeWei);
}
